import { useTranslation } from 'react-i18next';
// components
import { useSettingsContext } from '../components/settings';
//
import { allLangs, DEFAULT_LANG } from './config-lang';

// ----------------------------------------------------------------------

function normalizeLocaleCode(lang) {
  if (!lang) {
    return DEFAULT_LANG;
  }
  if (lang.startsWith('zh')) {
    return 'cn';
  }
  return lang.split('-')[0];
}

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const { onChangeDirectionByLang } = useSettingsContext();

  const activeCode = normalizeLocaleCode(i18n.resolvedLanguage || i18n.language);

  const currentLang =
    allLangs.find((_lang) => _lang.value === activeCode) || DEFAULT_LANG;

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
  };
}
